module.exports = __webpack_public_path__ + "static/media/buy_request_details_help_3.06d88c5a.png";